import React, { useEffect, useState } from "react";
import Contact from "../../Components/Contact";
import Designation from "../../Components/Designation";
import MainAvatar from "../../Components/MainAvatar";
import Navbar from "../../Components/Navbar";
import Project from "../../Components/Project";
import Skills from "../../Components/Skills";
import WorkExperience from "../../Components/WorkExperience";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let redirectTimeout;
    // Check if the user has visited before
    if (!localStorage.getItem("visitedBefore")) {
      // Set a flag in localStorage to indicate the user has visited
      

      redirectTimeout = setTimeout(() => {
      // Redirect to the specified page after 60 seconds
      localStorage.setItem('visitedBefore', 'true');
      navigate('/service/webstore');
    }, 60000); // 60 seconds // 60 seconds

    }
    const scrollListener = () => {
      // Check if the user has reached the end of the page
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        // Redirect to the /service URL
        setLoading(true)
        setTimeout(() => {
          navigate('/service');
          setLoading(false)
        }, 3000);
      }
    };

    // Attach the scroll listener
    window.addEventListener('scroll', scrollListener);

    // Cleanup listeners on component unmount
    return () => {
      clearTimeout(redirectTimeout);
      window.removeEventListener('scroll', scrollListener);
    };

  }, [navigate]);
  if(loading){
    return <div style={{width:"100vw",height:"90vh",color:"white"}}>You are redirected to service page, Thank you</div>
  }
  return (
    <>
      <Navbar />
      <div
        style={{
          width: "90%",
          margin: "6% auto",
        }}
      >
        <MainAvatar />
        <Designation />
        <WorkExperience />
        <Skills />
        <Project />
        <Contact />
      </div>
    </>
  );
};

export default Home;
